import React, { useState } from 'react';
import { type Theme, styled } from 'baseui';
import { Button, KIND, SIZE as BUTTON_SIZE } from 'baseui/button';
import { FormControl } from 'baseui/form-control';
import { Input, SIZE } from 'baseui/input';
import { CSS_VARIABLE_STAGE_VISIBLE_SCALE } from '../../../constants/stage-css-variables';
import type { SkeletonDataT } from '../../../types';
const LabelEditorContainer = styled<'div', {
  $xCoord: number;
  $yCoord: number;
}>('div', ({
  $xCoord: xCoord,
  $yCoord: yCoord,
  $theme
}) => ({
  position: 'absolute',
  top: `${yCoord + 60}px`,
  left: `${xCoord}px`,
  transform: 'translate(-50%, -50%)',
  paddingLeft: $theme.sizing.scale400,
  paddingRight: $theme.sizing.scale400,
  paddingBottom: $theme.sizing.scale400,
  pointerEvents: 'all',
  background: $theme.colors.backgroundPrimary,
  borderRadius: $theme.borders.radius200,
  boxShadow: `0 1px 4px hsla(0, 0%, 0%, 0.8)`,
  scale: `scale(var(${CSS_VARIABLE_STAGE_VISIBLE_SCALE}))`
}));
const ButtonContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  gap: $theme.sizing.scale100
}));
export const LABEL_EDITOR_ELEMENT_NAME = 'LabelEditor';
const UPDATE_TEXT = 'Update';
const CANCEL_TEXT = 'Cancel';
type PropsT = {
  selectedNode: SkeletonDataT['nodes'][number];
  onCancel: () => void;
  onUpdate: (label: string) => void;
};
export const LabelEditor = ({
  selectedNode,
  onCancel,
  onUpdate
}: PropsT) => {
  const [label, setLabel] = useState(selectedNode.id);
  return <LabelEditorContainer $xCoord={selectedNode.point[0]} $yCoord={selectedNode.point[1]}>
      <FormControl label={'Label'} overrides={{
      ControlContainer: {
        style: ({
          $theme
        }: {
          $theme: Theme;
        }) => ({
          marginBottom: $theme.sizing.scale200
        })
      }
    }}>
        <Input size={SIZE.mini} value={label} aria-label={'Label'} onChange={e => {
        setLabel(e.target.value);
      }} />
      </FormControl>
      <ButtonContainer>
        <Button size={BUTTON_SIZE.mini} kind={KIND.primary} onClick={() => {
        onUpdate(label);
      }}>
          {UPDATE_TEXT}
        </Button>
        <Button size={BUTTON_SIZE.mini} kind={KIND.secondary} onClick={onCancel}>
          {CANCEL_TEXT}
        </Button>
      </ButtonContainer>
    </LabelEditorContainer>;
};